<div class="navbar-container flex flex-column h-full" [class.collapsed]="isSidebarCollapsed()">
  <!-- Toast Notifications -->
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true" />
  
  <!-- Confirmation Dialog for Submit Registration -->
  <p-dialog
    [visible]="showSubmitConfirmDialog()"
    (visibleChange)="showSubmitConfirmDialog.set($event)"
    [modal]="true"
    [closable]="!isSubmittingRegistration()"
    [closeOnEscape]="!isSubmittingRegistration()"
    [dismissableMask]="false"
    [draggable]="false"
    [resizable]="false"
    styleClass="w-11 md:w-8 lg:w-6"
    header="Conferma Invio Anagrafica"
  >
    <div class="flex flex-column gap-3">
      <div class="flex align-items-start gap-3 p-3 border-round" style="background-color: #fff3cd; border: 1px solid #ffc107;">
        <i class="pi pi-exclamation-triangle text-2xl" style="color: #ff9800;" aria-hidden="true"></i>
        <div class="flex-1">
          <p class="m-0 font-semibold text-900 mb-2">Attenzione</p>
          <p class="m-0 text-700 line-height-3">
            Inviando l'anagrafica <strong>non sarà più possibile modificare i dati</strong> inseriti, 
            a meno che non venga richiesta una modifica da parte dell'operatore backoffice.
          </p>
        </div>
      </div>
      
      <p class="m-0 text-700">
        Sei sicuro di voler procedere con l'invio dell'anagrafica?
      </p>
    </div>
    
    <ng-template #footer>
      <div class="flex justify-content-end gap-2">
        <button
          pButton
          type="button"
          label="Annulla"
          icon="pi pi-times"
          severity="secondary"
          [outlined]="true"
          [disabled]="isSubmittingRegistration()"
          (click)="cancelSubmitRegistration()"
        ></button>
        <button
          pButton
          type="button"
          label="Conferma Invio"
          icon="pi pi-send"
          severity="success"
          [disabled]="isSubmittingRegistration()"
          [loading]="isSubmittingRegistration()"
          (click)="confirmSubmitRegistration()"
        ></button>
      </div>
    </ng-template>
  </p-dialog>
  
  <!-- Toggle Button -->
  <button
    class="sidebar-toggle-btn"
    (click)="toggleSidebar()"
    [attr.aria-label]="
      isSidebarCollapsed() ? 'Apri menu di navigazione' : 'Chiudi menu di navigazione'
    "
    [attr.aria-expanded]="!isSidebarCollapsed()"
    aria-controls="sidebar-links-region"
  >
    <i
      [class]="isSidebarCollapsed() ? 'pi pi-angle-right' : 'pi pi-angle-left'"
      aria-hidden="true"
    ></i>
  </button>

  <!-- Titolo Sezione -->
  <div class="sidebar-title p-4 border-bottom-1 border-200 mb-3">
    @if (
      currentUrl().includes('/axa/supplier-registration-wizard') ||
      currentUrl().includes('/axa/responsible-registration-wizard') ||
      currentUrl().includes('/axa/sub-responsible-registration-wizard')
    ) {
      <h2 class="text-base font-bold m-0" style="color: #00125b">{{ sidebarTitle() }}</h2>
    } @else if (isProfessionalsWizard()) {
      <div class="flex flex-column gap-1">
        <h2 class="text-xs font-bold text-secondary uppercase tracking-wider m-0"
          >Inserimento Anagrafica</h2>
        @if (professionalType()) {
          <span class="text-sm font-semibold" style="color: #00125b; line-height: 1.3">{{
            professionalType()
          }}</span>
        }
      </div>
    } @else {
      <h2 class="text-xs font-bold text-secondary uppercase tracking-wider m-0">{{
        sidebarTitle()
      }}</h2>
    }
  </div>

  <!-- Pulsante Dinamico (solo per sezione registro, ma non nei wizard) -->
  @if (
    isRegisterSection() &&
    !currentUrl().includes('/axa/supplier-registration-wizard') &&
    !currentUrl().includes('/axa/responsible-registration-wizard') &&
    !currentUrl().includes('/axa/sub-responsible-registration-wizard')
  ) {
    <div class="sidebar-action-btn-wrapper px-3 mb-3">
      @if (currentUrl().includes('/axa/responsibles-registry')) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium"
          (click)="navigateToAddEntity()"
          [attr.aria-label]="'Aggiungi nuovo responsible'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Responsible' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Responsabile</span>
        </button>
      } @else if (currentUrl().includes('/axa/sub-responsibles-registry')) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium"
          (click)="navigateToAddEntity()"
          [attr.aria-label]="'Aggiungi nuovo sub-responsabile'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Sub-Responsabile' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Sub-Responsabile</span>
        </button>
      } @else if (currentUrl().includes('/axa/suppliers-registry-sub-fornitori')) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium"
          (click)="navigateToAddEntity()"
          [attr.aria-label]="'Aggiungi nuovo sub-fornitore'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Sub-Fornitore' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Sub-Fornitore</span>
        </button>
      } @else if (isSubResponsabiliSection()) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium"
          (click)="navigateToAddEntity()"
          [attr.aria-label]="'Aggiungi nuovo sub-responsabile'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Sub-Responsabile' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Sub-Responsabile</span>
        </button>
      } @else if (isResponsabiliSection()) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium"
          (click)="navigateToAddEntity()"
          [attr.aria-label]="'Aggiungi nuovo responsible'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Responsible' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Responsabile</span>
        </button>
      } @else if (
        (isBackofficeProfessional() &&
          (currentUrl().includes('/axa/suppliers-registry') ||
            currentUrl().includes('/axa/professionals-registry'))) ||
        (currentRole() === 'backoffice_admin' &&
          currentUrl().includes('/axa/professionals-registry'))
      ) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium"
          (click)="router.navigate(['/axa/pre-registration'])"
          [attr.aria-label]="'Aggiungi nuovo fiduciario'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Fiduciario' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Fiduciario</span>
        </button>
      } @else {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium"
          (click)="router.navigate(['axa/supplier-registration-wizard'])"
          [attr.aria-label]="'Aggiungi nuovo fornitore'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Fornitore' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Fornitore</span>
        </button>
      }
    </div>
  }

  <!-- Pulsanti Dinamici per Gestione Contratti -->
  @if (isContractsSection()) {
    <div class="sidebar-action-btn-wrapper px-3 mb-3">
      @if (currentUrl().includes('-contracts-registry')) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium mb-2"
          (click)="router.navigate(['axa/' + navigationContext.getDomainPrefix() + '-contract-registration-wizard'])"
          [attr.aria-label]="'Aggiungi nuovo contratto'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Contratto' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Contratto</span>
        </button>
      } @else if (currentUrl().includes('-contract-sections')) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium mb-2"
          (click)="onNewBlockClick()"
          [attr.aria-label]="'Aggiungi nuovo blocco di testo'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Blocco di Testo' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Blocco di Testo</span>
        </button>
      } @else if (currentUrl().includes('-templates-registry') || currentUrl().includes('-contract-templates')) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium mb-2"
          (click)="router.navigate(['axa/' + navigationContext.getDomainPrefix() + '-contract-templates'], { queryParams: { new: 'true' } })"
          [attr.aria-label]="'Aggiungi nuovo template'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Template' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Template</span>
        </button>
      }
    </div>
  }

  <!-- Pulsanti Dinamici per Gestione Questionari e Checklist -->
  @if (isQuestionnaireSection()) {
    <div class="sidebar-action-btn-wrapper px-3 mb-3">
      @if (currentUrl().includes('/questionnaires')) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium mb-2"
          (click)="router.navigate(['/create-questionnaire'])"
          [attr.aria-label]="'Aggiungi nuovo questionario'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Questionario' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Questionario</span>
        </button>
      } @else if (currentUrl().includes('/list-file-checklist')) {
        <button
          class="fornitore-action-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium mb-2"
          (click)="router.navigate(['/create-file-checklist'])"
          [attr.aria-label]="'Aggiungi nuova checklist'"
          [attr.title]="isSidebarCollapsed() ? 'Aggiungi Checklist' : ''"
        >
          <i class="pi pi-plus text-lg" aria-hidden="true"></i>
          <span class="btn-text">Checklist</span>
        </button>
      }
    </div>
  }

  <!-- Lista Link -->
  <nav
    id="sidebar-links-region"
    class="sidebar-links flex-grow-1 px-3"
    aria-label="Navigazione laterale"
  >
    @if (
      currentUrl().includes('/axa/supplier-registration-wizard') ||
      currentUrl().includes('/axa/responsible-registration-wizard') ||
      currentUrl().includes('/axa/sub-responsible-registration-wizard')
    ) {
      <!-- Menu Wizard Steps (Fornitore/Responsabile/Sub-Responsabile con icone e pallini di stato) -->
      @for (item of items(); track item.label; let idx = $index) {
        <div
          (click)="onItemClick(item)"
          (keydown.enter)="!item.disabled && onItemClick(item)"
          (keydown.space)="!item.disabled && onItemClick(item)"
          [class]="
            'wizard-step-item flex align-items-center gap-3 p-3 border-round mb-2 ' +
            (item.styleClass || '')
          "
          [class.cursor-pointer]="!item.disabled"
          [class.cursor-not-allowed]="item.disabled"
          [pTooltip]="item.title || ''"
          [tooltipDisabled]="!item.title || !item.disabled"
          tooltipPosition="right"
          [style.pointer-events]="item.disabled ? 'none' : 'auto'"
          role="button"
          tabindex="0"
          [attr.aria-current]="item.styleClass?.includes('active') ? 'step' : null"
          [attr.aria-disabled]="item.disabled"
        >
          @if (item.icon) {
            <i [class]="item.icon + ' text-xl'" aria-hidden="true"></i>
          }
          <span class="font-medium flex-1">{{ item.label }}</span>
          <!-- Pallino di stato sulla destra -->
          <i [class]="getWizardStepStatusIcon(idx)" aria-hidden="true"></i>
        </div>
      }
    } @else if (currentUrl().includes('-contract-registration-wizard')) {
      <!-- Menu Wizard Steps Contratti (con icone e pallini di stato) -->
      @for (item of items(); track item.label; let idx = $index) {
        <div
          (click)="onItemClick(item)"
          (keydown.enter)="!item.disabled && onItemClick(item)"
          (keydown.space)="!item.disabled && onItemClick(item)"
          [class]="
            'wizard-step-item flex align-items-center gap-3 p-3 border-round mb-2 ' +
            (item.styleClass || '')
          "
          [class.cursor-pointer]="!item.disabled"
          [class.cursor-not-allowed]="item.disabled"
          [pTooltip]="item.title || ''"
          [tooltipDisabled]="!item.title || !item.disabled"
          tooltipPosition="right"
          role="button"
          tabindex="0"
          [attr.aria-current]="item.styleClass?.includes('active') ? 'step' : null"
          [attr.aria-disabled]="item.disabled"
        >
          @if (item.icon) {
            <i [class]="item.icon + ' text-xl'" aria-hidden="true"></i>
          }
          <span class="font-medium flex-1">{{ item.label }}</span>
          <!-- Pallino di stato sulla destra -->
          <i [class]="getWizardStepStatusIcon(idx)" aria-hidden="true"></i>
        </div>
      }

      <!-- Divider e Pulsante Checklist fisso per wizard contratti -->
      @if (isContractWizard()) {
        <div class="border-top-1 border-300 my-3"></div>
        <button
          class="checklist-btn w-full flex align-items-center justify-content-center gap-2 p-3 border-round cursor-pointer border-none font-medium"
          (click)="openChecklist()"
          [disabled]="!checklistAvailable()"
          [pTooltip]="
            checklistAvailable()
              ? 'Apri checklist'
              : 'Salva prima il contratto in bozza per abilitare la checklist'
          "
          tooltipPosition="right"
          [attr.aria-label]="
            checklistAvailable()
              ? 'Apri checklist'
              : 'Checklist non disponibile. Salva prima il contratto in bozza.'
          "
          [attr.aria-disabled]="!checklistAvailable()"
          [attr.title]="
            isSidebarCollapsed()
              ? checklistAvailable()
                ? 'Checklist'
                : 'Salva contratto per abilitare'
              : ''
          "
        >
          <i class="pi pi-list-check text-lg" aria-hidden="true"></i>
          <span class="btn-text">Checklist</span>
        </button>
      }
    } @else if (
      currentUrl().includes('/axa/professionals-general-data') ||
      currentUrl().includes('/axa/professionals-specific-data') ||
      currentUrl().includes('/axa/professionals-staff-collaborators') ||
      currentUrl().includes('/axa/professionals-administrative-staff') ||
      currentUrl().includes('/axa/professionals-collaborators') ||
      currentUrl().includes('/axa/professionals-contracts') ||
      currentUrl().includes('/axa/professionals-questionnaire-attachments') ||
      currentUrl().includes('/axa/vrf-questionnaire')
    ) {
      <!-- Menu Wizard Steps Professionals (con icone e pallini di stato) -->
      @for (item of items(); track item.label || $index; let idx = $index) {
        <!-- Check if item is a separator -->
        @if (item.separator) {
          <div class="border-top-1 border-300 my-3 mx-2" role="separator"></div>
        } @else {
          <div
            (click)="onItemClick(item)"
            (keydown.enter)="!item.disabled && onItemClick(item)"
            (keydown.space)="!item.disabled && onItemClick(item)"
            [class]="
              'wizard-step-item flex align-items-center gap-3 p-3 border-round mb-2 ' +
              (item.styleClass || '')
            "
            [class.cursor-pointer]="!item.disabled"
            [class.cursor-not-allowed]="item.disabled"
            [pTooltip]="item.title || ''"
            [tooltipDisabled]="!item.title || !item.disabled"
            tooltipPosition="right"
            role="button"
            tabindex="0"
            [attr.aria-current]="item.styleClass?.includes('active') ? 'step' : null"
            [attr.aria-disabled]="item.disabled"
          >
            @if (item.icon) {
              <i [class]="item.icon + ' text-xl'" aria-hidden="true"></i>
            }
            <span class="font-medium flex-1">{{ item.label }}</span>
            <!-- Pallino di stato sulla destra -->
            @if (item.statusIcon) {
              <i [class]="item.statusIcon" aria-hidden="true"></i>
            } @else {
              <i [class]="getWizardStepStatusIcon(idx)" aria-hidden="true"></i>
            }
          </div>
        }
      }
      
      <!-- Submit Registration Button - Only show in editable mode and not on contract signature page -->
      @if (!isReadOnlyMode() && !currentUrl().includes('/axa/professionals-contracts')) {
        <div class="border-top-1 border-300 my-3 mx-2" role="separator"></div>
        
        <div class="px-2">
          @if (!areRequiredStepsCompleted()) {
            <small class="text-600 block mb-2 text-center" role="status">
              <i class="pi pi-info-circle mr-1" aria-hidden="true"></i>
              Completa tutti gli step obbligatori
            </small>
          }
          
          @if (professionalsWizardService.isNetworkOnboarding()) {
            @let bsStatus = professionalsWizardService.networkBodyShopStatus();
            @if (bsStatus === null) {
              <!-- Status in caricamento: spinner neutro -->
              <button pButton type="button" label="Caricamento..." icon="pi pi-spin pi-spinner" class="w-full" [disabled]="true"></button>
            } @else if (bsStatus === 'ACTIVE') {
              <!-- Carrozzeria già attiva: mostra Sospendi + Elimina -->
              <div class="flex flex-column gap-2">
                <button
                  pButton
                  type="button"
                  label="Sospendi Carrozzeria"
                  icon="pi pi-pause"
                  severity="warn"
                  class="w-full"
                  [loading]="isActivatingNetworkBodyShop()"
                  (click)="onSuspendNetworkBodyShop()"
                ></button>
                <button
                  pButton
                  type="button"
                  label="Elimina Carrozzeria"
                  icon="pi pi-trash"
                  severity="danger"
                  class="w-full"
                  [disabled]="isActivatingNetworkBodyShop()"
                  (click)="onDeleteNetworkBodyShop()"
                ></button>
              </div>
            } @else if (bsStatus === 'SUSPENDED') {
              <!-- Carrozzeria sospesa: mostra Riattiva + Elimina -->
              <div class="flex flex-column gap-2">
                <button
                  pButton
                  type="button"
                  label="Riattiva Carrozzeria"
                  icon="pi pi-play"
                  severity="success"
                  class="w-full"
                  [loading]="isActivatingNetworkBodyShop()"
                  (click)="onActivateNetworkBodyShop()"
                ></button>
                <button
                  pButton
                  type="button"
                  label="Elimina Carrozzeria"
                  icon="pi pi-trash"
                  severity="danger"
                  class="w-full"
                  [disabled]="isActivatingNetworkBodyShop()"
                  (click)="onDeleteNetworkBodyShop()"
                ></button>
              </div>
            } @else {
              <!-- Status sconosciuto/loading o nuova carrozzeria: mostra Attiva -->
              <button
                pButton
                type="button"
                label="Attiva Carrozzeria"
                icon="pi pi-check-circle"
                severity="success"
                class="w-full"
                [disabled]="!areRequiredStepsCompleted()"
                [loading]="isActivatingNetworkBodyShop()"
                pTooltip="Completa Dati Specifici e Allegati per attivare la carrozzeria"
                tooltipPosition="right"
                (click)="onActivateNetworkBodyShop()"
              ></button>
            }
          } @else {
            <button
              pButton
              type="button"
              label="Invia Anagrafica"
              icon="pi pi-send"
              severity="success"
              class="w-full"
              [disabled]="!canSubmitRegistration() || isSubmittingRegistration()"
              [loading]="isSubmittingRegistration()"
              [pTooltip]="submitRegistrationTooltip()"
              tooltipPosition="right"
              (click)="onSubmitRegistration()"
            ></button>
          }
        </div>
      }
    } @else if (isRegisterSection()) {
      <!-- Menu Registro - rendered from items signal -->
      @for (item of items(); track item.label) {
        <a
          [routerLink]="item.routerLink"
          routerLinkActive="active-menu-item"
          class="menu-item flex align-items-center gap-2 p-3 border-round cursor-pointer no-underline mb-2"
          [attr.aria-label]="'Vai a ' + item.label"
          [attr.title]="isSidebarCollapsed() ? item.label : ''"
        >
          <i [class]="item.icon + ' text-lg'" aria-hidden="true"></i>
          <span class="menu-text font-medium">{{ item.label }}</span>
        </a>
      }
    } @else if (isContractsSection()) {
      <!-- Menu Contratti -->
      @for (item of items(); track item.label) {
        <a
          [routerLink]="item.routerLink || null"
          routerLinkActive="active-menu-item"
          (click)="item.command && onItemClick(item)"
          class="menu-item flex align-items-center gap-2 p-3 border-round cursor-pointer no-underline mb-2"
          [attr.aria-label]="'Vai a ' + item.label"
          [attr.title]="isSidebarCollapsed() ? item.label : ''"
        >
          <i [class]="item.icon + ' text-lg'" aria-hidden="true"></i>
          <span class="menu-text font-medium">{{ item.label }}</span>
        </a>
      }
    } @else {
      <!-- Menu Questionari -->
      @for (item of items(); track item.label) {
        <a
          [routerLink]="item.routerLink"
          routerLinkActive="active-menu-item"
          class="menu-item flex align-items-center gap-2 p-3 border-round cursor-pointer no-underline mb-2"
          [attr.aria-label]="'Vai a ' + item.label"
          [attr.title]="isSidebarCollapsed() ? item.label : ''"
        >
          <i [class]="item.icon + ' text-lg'" aria-hidden="true"></i>
          <span class="menu-text font-medium">{{ item.label }}</span>
        </a>
      }
    }
  </nav>

</div>
